import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/components/ThemeProvider";
import { AuthProvider } from "@/contexts/AuthContext";
import { BrandingProvider } from "@/contexts/BrandingContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/layout/AppLayout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Users from "@/pages/Users";
import UserProfile from "@/pages/UserProfile";
import MyProfile from "@/pages/MyProfile";
import MyTasks from "@/pages/MyTasks";
import Activity from "@/pages/Activity";
import RolesPermissions from "@/pages/RolesPermissions";
import ReportRecipients from "@/pages/ReportRecipients";
import ComingSoon from "@/pages/ComingSoon";
import Topics from "@/pages/Topics";
import Approvals from "@/pages/Approvals";
import NotAvailable from "@/pages/NotAvailable";
import SettingsLayout from "@/pages/settings/SettingsLayout";
import Organisation from "@/pages/settings/Organisation";
import Appearance from "@/pages/settings/Appearance";
import NavigationBuilder from "@/pages/settings/NavigationBuilder";
import LanguageLabels from "@/pages/settings/LanguageLabels";
import Integrations from "@/pages/settings/Integrations";
import Notifications from "@/pages/settings/Notifications";
import DataPortability from "@/pages/settings/DataPortability";
import SystemHealth from "@/pages/settings/SystemHealth";
import TimeActivity from "@/pages/settings/TimeActivity";
import TaskCategories from "@/pages/settings/TaskCategories";
import Checklists from "@/pages/settings/Checklists";

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <BrandingProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />

              <Route element={<ProtectedRoute />}>
                <Route path="/" element={<AppLayout />}>
                  <Route index element={<Dashboard />} />
                  <Route path="profile" element={<MyProfile />} />
                  <Route path="tasks" element={<MyTasks />} />
                  <Route path="tasks/:section" element={<MyTasks />} />
                  <Route path="topics" element={<Topics />} />
                  <Route path="home/approvals" element={<Approvals />} />
                  <Route path="team/members" element={<Users />} />
                  <Route path="team/members/:id" element={<UserProfile />} />
                  <Route path="team/activity" element={<Activity />} />

                  <Route path="settings" element={<SettingsLayout />}>
                    <Route index element={<Navigate to="/settings/organisation" replace />} />
                    <Route path="organisation" element={<Organisation />} />
                    <Route path="roles" element={<RolesPermissions />} />
                    <Route path="recipients" element={<ReportRecipients />} />
                    <Route path="language" element={<LanguageLabels />} />
                    <Route path="appearance" element={<Appearance />} />
                    <Route path="navigation" element={<NavigationBuilder />} />
                    <Route path="notifications" element={<Notifications />} />
                    <Route path="time" element={<TimeActivity />} />
                    <Route path="categories" element={<TaskCategories />} />
                    <Route path="checklists" element={<Checklists />} />
                    <Route path="data" element={<DataPortability />} />
                    <Route path="health" element={<SystemHealth />} />
                    <Route path="theme" element={<Navigate to="/settings/appearance" replace />} />
                    <Route path="integrations" element={<Integrations />} />
                  </Route>

                  <Route path="*" element={<NotAvailable />} />
                </Route>
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </div>
        </BrandingProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
